import { useEffect, useState } from 'react';

import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

interface IUseMapSizeParams {
  mapRef: React.RefObject<HTMLDivElement>;
  ymaps: YMaps.IYMaps | null;
}

interface IMapSize {
  width: number;
  height: number;
}

const RETRY_TIMES = 3;

const DEFAULT_MAP_SIZE = {
  width: 812,
  height: 348,
};

const RETRY_INTERVAL = 200;

/**
 * @description
 * Хук вычисляет первоначальные размеры карты.
 * Карта растягивается на 100% по высоте и ширине, но высота определяется не сразу, а после вычисления высоты фильтров.
 * Поэтому хук запускает интервал для проверки, когда размеры карты вычислились.
 * Ограничен 3 попытками, далее устанавливается размер по умолчанию.
 */
export const useMapSize = ({ mapRef, ymaps }: IUseMapSizeParams): IMapSize | undefined => {
  const [mapSize, setMapSize] = useState<IMapSize>();

  const viewMode = useListingLayoutViewModeSelector();

  useEffect(() => {
    const mapElement = mapRef.current;

    if (!ymaps || !mapElement || viewMode === 'list' || mapSize) {
      return;
    }

    let retryCount = 0;

    const interval = setInterval(() => {
      const { width, height } = mapElement.getBoundingClientRect();

      if (width && height) {
        setMapSize({ width, height });

        clearInterval(interval);
      }

      retryCount++;

      if (retryCount === RETRY_TIMES) {
        setMapSize(DEFAULT_MAP_SIZE);

        clearInterval(interval);
      }
    }, RETRY_INTERVAL);
  }, [mapRef, mapSize, viewMode, ymaps]);

  return mapSize;
};
